import { useLayoutEffect } from "react";

// Canonical host = the host that actually serves 200 (apex 307-redirects to www).
export const SITE = "https://www.daaniyalkhan.com";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Imperatively set per-route <head>. og:* uses property= (Open-Graph-Spec),
// twitter:* uses name= (Twitter-Card-Spec) - index.html deklariert beide genauso,
// damit Tags in place aktualisiert statt dupliziert werden.
export function applySeo({ title, description, path, ogType }) {
  if (typeof document === "undefined") return;
  const p = path != null ? path : window.location.pathname;
  const url = SITE + (p === "/" ? "/" : p.replace(/\/$/, ""));
  if (title) {
    document.title = title;
    upsertMeta("name", "title", title);
    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
  }
  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:description", description);
  }
  upsertLink("canonical", url);
  upsertMeta("property", "og:url", url);
  upsertMeta("name", "twitter:url", url);
  // Immer setzen, nicht nur wenn uebergeben: sonst behaelt eine Sektionsseite
  // nach SPA-Navigation von einem Artikel weg faelschlich og:type=article.
  upsertMeta("property", "og:type", ogType || "website");

  // Re-point inherited hreflang alternates at the current route. The static
  // index.html defaults them all to the homepage, which would cluster every
  // page with "/". Mirrors the per-route sitemap entries.
  document.head
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((el) => {
      const lang = el.getAttribute("hreflang");
      if (!lang) return;
      el.setAttribute(
        "href",
        lang === "en" || lang === "x-default" ? url : `${url}?lang=${lang}`
      );
    });
}

// Renders nothing; applies SEO head tags for the current route.
// useLayoutEffect runs synchronously before the double-rAF that fires
// 'prerender-ready', so @prerenderer captures the updated <head>.
export default function Seo({ title, description, path, ogType }) {
  useLayoutEffect(() => {
    applySeo({ title, description, path, ogType });
  }, [title, description, path, ogType]);
  return null;
}
